export default __webpack_public_path__ + "static/media/palcare_logo.68c3bae9.jpg";